// src/context/AuthContext.js (FINALIZED)
import React, { useContext, useState, useEffect } from 'react';
// Ensure auth and db are correctly imported from your firebase init file
import { auth, db } from '../firebase'; 
// Import onAuthStateChanged and signOut for authentication state and logging out
import { onAuthStateChanged, signOut as firebaseSignOut } from 'firebase/auth'; 
// Import doc and getDoc for fetching Firestore data
import { doc, getDoc } from 'firebase/firestore'; 

const AuthContext = React.createContext();

export function useAuth() {
    return useContext(AuthContext);
}

export function AuthProvider({ children }) {
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true);

    // 1. LOGOUT FUNCTION: Expose it via the context value
    const logout = () => {
        return firebaseSignOut(auth); 
    };

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                // --- 1. Fetch Firestore Profile (users collection) ---
                const userDocRef = doc(db, 'users', user.uid);
                const userDocSnap = await getDoc(userDocRef);
                
                if (userDocSnap.exists()) {
                    const userData = userDocSnap.data();
                    let hotelName = null;
                    
                    // 2. CRITICAL FIX: Fetch the hotel name if hotelId exists in the user's profile
                    if (userData.hotelId) {
                        try {
                            const hotelDocSnap = await getDoc(doc(db, 'hotels', userData.hotelId));
                            if (hotelDocSnap.exists()) {
                                hotelName = hotelDocSnap.data().name;
                            }
                        } catch (e) {
                            console.error("Could not fetch hotel name:", e);
                        }
                    }

                    // 3. Set Current User State with ALL necessary data
                    setCurrentUser({ 
                        ...user, 
                        ...userData, 
                        hotelName // Now HotelDashboard can display the name and use it
                    }); 

                } else {
                    // 🔑 CRITICAL FIX: If no Firestore profile, the user is signed in but unauthorized.
                    // Log them out to prevent access and signal the missing data issue.
                    console.warn("No Firestore profile found for user:", user.uid, "Forcing signout.");
                    setCurrentUser(null);
                    firebaseSignOut(auth); // Force the user to sign out completely
                }
            } else {
                // User logged out
                setCurrentUser(null);
            }
            setLoading(false);
        });

        return unsubscribe;
    }, []);

    const value = {
        user: currentUser, // This object now contains hotelId, role, and hotelName
        loading,
        logout, // Exposes the working logout function
    };

    return (
        <AuthContext.Provider value={value}>
            {/* Wait for authentication state and data to load before rendering children */}
            {!loading && children}
        </AuthContext.Provider>
    );
}